import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/ELLY_Logo_als_Pfad.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "card-img-circle" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = { class: "row mt-4" }
const _hoisted_4 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_translate = _resolveComponent("translate")!
  const _component_AnimatedInput = _resolveComponent("AnimatedInput")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Dialog, {
      visible: _ctx.show,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.show) = $event)),
      class: "container",
      onSubmit: _withModifiers(_ctx.confirm, ["prevent"]),
      modal: "",
      closable: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          class: "p-button-primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.rpcClient.logout()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_translate, { "translate-context": "button" }, {
              default: _withCtx(() => [
                _createTextVNode("Ausloggen")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          id: "twoFactorCodeSubmitButton",
          type: "submit",
          disabled: !_ctx.twoFactorCode,
          variant: "p-button-success"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_translate, { "translate-context": "button" }, {
              default: _withCtx(() => [
                _createTextVNode("Weiter")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("h3", _hoisted_2, [
          _createVNode(_component_translate, null, {
            default: _withCtx(() => [
              _createTextVNode("Zwei-Faktor-Authentifizierung")
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_translate, null, {
          default: _withCtx(() => [
            _createTextVNode(" Bitte geben Sie den Zwei-Faktor Code aus Ihrer Authenticator-App ein. ")
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_AnimatedInput, {
              class: "w-100 mt-2",
              modelValue: _ctx.twoFactorCode,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.twoFactorCode) = $event)),
              modelModifiers: { lazy: true, trim: true },
              type: "text",
              label: _ctx.i18n.$gettext('Zwei-Faktor Code')
            }, null, 8, ["modelValue", "label"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onSubmit"])
  ]))
}